import React, { useEffect } from "react";
import style from "./style.module.scss";
import {
  AdminContentWrapper,
  AdminHeader,
  Button,
  CheckboxV2,
  Loader,
} from "../../components";
import { useAppDispatch, useAppSelector } from "../../store";
import {
  clearAdminSperrmuellRegeln,
  getAdminSperrmuellRegeln,
  setAdminSperrmuellRegeln,
  setSperrmuellRegeln,
} from "../../store/slices/admin";
import appConfig from "../../util/appConfig";

const AdminSperrmüllRegeln = () => {
  const dispatch = useAppDispatch();

  const { isAdminLoaderActive, sperrmuellRegeln } = useAppSelector(
    (state) => state.admin,
  );

  const mapRules = [
    {
      title: "Schwarze Liste Regel ignorieren",
      value: sperrmuellRegeln.ignoreBlackListRule ?? false,
      setter: () =>
        dispatch(
          setSperrmuellRegeln({
            key: "ignoreBlackListRule",
            value: !sperrmuellRegeln.ignoreBlackListRule,
          }),
        ),
      isActive: ["leverkusen", "ebe"].includes(appConfig.logo),
    },
    {
      title: "Weiße Liste Regel ignorieren",
      value: sperrmuellRegeln.ignoreWhiteListRule ?? false,
      setter: () =>
        dispatch(
          setSperrmuellRegeln({
            key: "ignoreWhiteListRule",
            value: !sperrmuellRegeln.ignoreWhiteListRule,
          }),
        ),
      isActive: ["leverkusen", "ebe"].includes(appConfig.logo),
    },
    {
      title: "Graue Liste Regel ignorieren",
      value: sperrmuellRegeln.ignoreGreyListRule ?? false,
      setter: () =>
        dispatch(
          setSperrmuellRegeln({
            key: "ignoreGreyListRule",
            value: !sperrmuellRegeln.ignoreGreyListRule,
          }),
        ),
      isActive: ["leverkusen", "ebe"].includes(appConfig.logo),
    },
    {
      title: "Gegenstände-Quantität Regel ignorieren",
      value: sperrmuellRegeln.ignoreItemQuantityRule ?? false,
      setter: () =>
        dispatch(
          setSperrmuellRegeln({
            key: "ignoreItemQuantityRule",
            value: !sperrmuellRegeln.ignoreItemQuantityRule,
          }),
        ),
      isActive: ["leverkusen", "ebe"].includes(appConfig.logo),
    },
    {
      title: "Nachricht Regel ignorieren",
      value: sperrmuellRegeln.ignoreMessageRule ?? false,
      setter: () =>
        dispatch(
          setSperrmuellRegeln({
            key: "ignoreMessageRule",
            value: !sperrmuellRegeln.ignoreMessageRule,
          }),
        ),
      isActive: ["leverkusen"].includes(appConfig.logo),
    },
    {
      title: "Anmeldung mit sonstigen Gegenständen ignorieren",
      value: sperrmuellRegeln.ignoreSonstigeRule ?? false,
      setter: () =>
        dispatch(
          setSperrmuellRegeln({
            key: "ignoreSonstigeRule",
            value: !sperrmuellRegeln.ignoreSonstigeRule,
          }),
        ),
      isActive: ["leverkusen"].includes(appConfig.logo),
    },
    {
      title: "Volumen Regel ignorieren",
      value: sperrmuellRegeln.ignoreVolumeRule ?? false,
      setter: () =>
        dispatch(
          setSperrmuellRegeln({
            key: "ignoreVolumeRule",
            value: !sperrmuellRegeln.ignoreVolumeRule,
          }),
        ),
      isActive: ["leverkusen", "ebe"].includes(appConfig.logo),
    },
  ];

  useEffect(() => {
    dispatch(getAdminSperrmuellRegeln());

    return () => {
      dispatch(clearAdminSperrmuellRegeln());
    };
  }, []);

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <AdminHeader pageTitle={"Sperrmüll-Regeln"} hasBtnGroup={false} />
      <AdminContentWrapper>
        {isAdminLoaderActive ? null : (
          <>
            <div className={style.checkBoxItemsWrapper}>
              {mapRules
                .filter((el) => el.isActive)
                .map((el) => {
                  return (
                    <CheckboxV2
                      onChange={el.setter}
                      text={el.title}
                      value={el.value}
                      key={el.title}
                    />
                  );
                })}
            </div>
            <div className={style.btnWrapper}>
              <Button
                text={"Speichern"}
                width="222"
                backgroundColor={appConfig.mainColor}
                onClick={() => {
                  dispatch(setAdminSperrmuellRegeln(sperrmuellRegeln));
                }}
              />
            </div>
          </>
        )}
      </AdminContentWrapper>
      {isAdminLoaderActive && <Loader />}
    </div>
  );
};

export default AdminSperrmüllRegeln;
